export enum LastUsedAuthMethod {
  Google = "google",
  Apple = "apple",
  EmailPassword = "email-password",
}

export type LastUsedAuthMethodRecord = {
  method: LastUsedAuthMethod;
  updatedAtMs: number;
};

export const isLastUsedAuthMethod = (value: unknown): value is LastUsedAuthMethod => {
  return Object.values(LastUsedAuthMethod).includes(value as LastUsedAuthMethod);
};
